@if (parentFormGroup &&
  parentFormGroup.controls &&
  parentFormGroup.controls[this.controlName]) {
  <div
    class="component-container">
    @if (label) {
      <div class="text-type-13 label">{{ label }}:</div>
    }
    @if (displaySearch) {
      <form
        [formGroup]="parentFormGroup"
        >
        <div class="filter-section search-section">
          <div class="search">
            <mat-icon svgIcon="search"></mat-icon>
            <input
              [formControlName]="controlName"
              matInput
              placeholder="Search"
              >
          </div>
        </div>
      </form>
    }
    <div class="checkbox-section">
      @if (displaySelectAll) {
        @if (!parentFormGroup.controls[controlName].value) {
          <mat-checkbox
            (change)="onAllCheckboxChange($event)"
            [checked]="isAllChecked"
            [indeterminate]="isPartiallyChecked()"
            class="option"
            color="primary"
            value="all">
            All
          </mat-checkbox>
        }
      }
      @if (filteredOptions.length === 0) {
        <div class="no-options-found .text-type-11">
          No options found
        </div>
      }
      @for (option of filteredOptions; track option; let i = $index) {
        <div class="option">
          <mat-checkbox
            (change)="onCheckboxChange($event, i)"
            [checked]="option.isChecked"
            [value]="option.value"
            color="primary">
            {{ option.label }}
          </mat-checkbox>
        </div>
      }
    </div>
  </div>
}



